import { NotificationsManager } from "./lib/NotificationsManager";
export * from "./lib/NotificationsManager";
export * from "./lib/sidebar/SidebarButton";

export default NotificationsManager;
